module.exports = __webpack_public_path__ + "static/img/slogn-fr.b16eb4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/slogn/slogn-fr.png
// module id = TlC+
// module chunks = 1